import React from 'react';
import '../template-file-css/document-file-template.css';


export const CMC_LegalPacket = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='CMC_LegalPacket' className='file-pdf-document'>
            <div className='file-template'>


            <p className='w-750'>
                    <h3>{`Intake Packet Child/Adolescent`}</h3>
                </p>
                <p className='w-750'>{`(To be explained to staff and signed by consumer, then FILED IN CHART - Individual will be given "Individual Orientation" at intake)`}
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`C&A COMPLETE INTAKE/ASSESSMENT CHECKLIST`}</span>
                    <span className='small'>(Please initial by each completed checklist item)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_1' name='cbCompleteIntakeAssessment_1' className='add-only' value='IntakePacketwithSignedConsentFormsWithCsrCmc' /> {`Intake Packet with Signed Consent Forms (with Csr/CMC Staff Signatures)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_2' name='cbCompleteIntakeAssessment_2' className='add-only' value='SafetyPlanWithSignature' /> {`Safety Plan (with Signatures)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_3' name='cbCompleteIntakeAssessment_3' className='add-only' value='TransitionDischargePlanWithCsrCmcStaffSignatures' /> {`Transition/Discharge Plan (with Csr/ CMC Staff Signatures)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_4' name='cbCompleteIntakeAssessment_4' className='add-only' value='IndividualRecoveryPlanWithCsrCmgStaffSignatures' /> {`Individual Recovery Plan [with Csr/ CMG Staff Signatures)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_5' name='cbCompleteIntakeAssessment_5' className='add-only' value='MedicationLog' /> {`Medication Log`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_6' name='cbCompleteIntakeAssessment_6' className='add-only' value='OrderForServicesWithQualifiedProfessionalPrintedNameSignatures' /> {`Order for Services (with Qualified Professional Printed Name/Signatures)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                        <input type='checkbox' id='cbCompleteIntakeAssessmentOne_6' name='cbCompleteIntakeAssessmentOne_6' className='add-only' value='Cafas' /> {`CAFAS`}                            
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCafas_1' name='cbCafas_1' className='add-only' value='BehavioralHealthAssessmentWithAssessor' /> {`Behavioral Health Assessment (with CMC Assessor/Clinical Dir. Signatures)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCafas_2' name='cbCafas_2' className='add-only' value='BirpProgressNote' /> {`BIRP Progress Note(s) in NoteNetic (BHA &!RP)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCafas_3' name='cbCafas_3' className='add-only' value='BehavioralHealthAssessmentUploadedIn' /> {`Behavioral Health Assessment uploaded in NoteNetic`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCafas_4' name='cbCafas_4' className='add-only' value='IndividualRecoveryPlanUploadedIn' /> {`Individual Recovery Plan Uploaded in NoteNetic`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                        <input type='checkbox' id='cbCafasOne_4' name='cbCafasOne_4' className='add-only' value='AllClinicalDocsViaEmail' /> {`All Clinical Docs sent via email`}                            
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAllClinicalDocsSentViaEmail_1' name='cbAllClinicalDocsSentViaEmail_1' className='add-only' value='OriginalsOfCOMPLETEDIntakePacketTurnedInToCmgOffice' /> {`Originals of COMPLETED intake packet turned in to CMG Office`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAllClinicalDocsSentViaEmail_2' name='cbAllClinicalDocsSentViaEmail_2' className='add-only' value='VerifiedDiagnosisWithin' /> {`Verified diagnosis within 30 days:`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Appt Date for Psychiatrist`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='date' id='txtDateForPsychiatrist' name='txtDateForPsychiatrist' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <span className='eleHeader'>{`Assessor Name:`}</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>{`Date Completed:`}</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>{`Date Submitted:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtAssessorName' name='txtAssessorName' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateCompleted' name='txtDateCompleted' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateForSubmitted' name='txtDateForSubmitted' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`C&A CONTENTS OF INTAKE PACKET`}</span>
                    <span className='small'>(Please initial by each completed checklist item)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_1' name='cbCompleteIntakeAssessment_1' className='add-only' value='StatementOfGuardianship' /> {`Statement of Guardianship`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_2' name='cbCompleteIntakeAssessment_2' className='add-only' value='AcknowledgementOfFreedomOfChoice' /> {`Acknowledgement of Freedom of Choice`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_3' name='cbCompleteIntakeAssessment_3' className='add-only' value='RightsAsAIndividual' /> {`Rights as a Individual`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_4' name='cbCompleteIntakeAssessment_4' className='add-only' value='ConsentToTreatment' /> {`Consent to Treatment`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_5' name='cbCompleteIntakeAssessment_5' className='add-only' value='LimitsofConfidentiality' /> {`Limits of Confidentiality`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_6' name='cbCompleteIntakeAssessment_6' className='add-only' value='ContactSpecifications' /> {`ContactSpecifications`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_7' name='cbCompleteIntakeAssessment_7' className='add-only' value='AcknowledgementOfLimitsOfConfidentialityAndOtherProvisions' /> {`Acknowledgement Of Limits Of Confidentiality And Other Provisions`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_8' name='cbCompleteIntakeAssessment_8' className='add-only' value='AdvancedDirectiveForm' /> {`Advanced Directive Form`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_9' name='cbCompleteIntakeAssessment_9' className='add-only' value='SchoolInvolvementConsentForm' /> {`School Involvement Consent Form`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_10' name='cbCompleteIntakeAssessment_10' className='add-only' value='ReleaseToProvideTransportationConsentForm' /> {`Release to Provide Transportation Consent Form`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_11' name='cbCompleteIntakeAssessment_11' className='add-only' value='AudioNideoConsentForm' /> {`Audio/video Consent Form`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_12' name='cbCompleteIntakeAssessment_12' className='add-only' value='ConsentToPublicationOfPhotographsAndFilm' /> {`Consent to Publication of Photographs and Film`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_13' name='cbCompleteIntakeAssessment_13' className='add-only' value='AcknowledgementOfGroup' /> {`Acknowledgement of Group`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_14' name='cbCompleteIntakeAssessment_14' className='add-only' value='GrievancePolicyAcknowledgement' /> {`Grievance Policy Acknowledgement`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_15' name='cbCompleteIntakeAssessment_15' className='add-only' value='HipaaPrivacyAcknowledgement' /> {`HiPAA Privacy Acknowledgement`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_16' name='cbCompleteIntakeAssessment_16' className='add-only' value='FinancialDataForm' /> {`Financial Data Form`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_17' name='cbCompleteIntakeAssessment_17' className='add-only' value='AuthorizationOfTreatmentPlan' /> {`Authorization of Treatment Plan`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_18' name='cbCompleteIntakeAssessment_18' className='add-only' value='AuthorizationForReleaseOfInformationMedicalRecords' /> {`Authorization for Release of Information/Medical Records`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_19' name='cbCompleteIntakeAssessment_19' className='add-only' value='EmergencyContactInformation' /> {`Emergency Contact Information`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_20' name='cbCompleteIntakeAssessment_20' className='add-only' value='SafetyPlan' /> {`Safety Plan`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_21' name='cbCompleteIntakeAssessment_21' className='add-only' value='TreatmentPlanSignaturePage' /> {`Treatment Plan Signature Page`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_22' name='cbCompleteIntakeAssessment_22' className='add-only' value='TransitionDischargePlanSignaturePage' /> {`Transition/Discharge Plan Signature Page`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_23' name='cbCompleteIntakeAssessment_23' className='add-only' value='AccessToEmergencyServiceAfterHours' /> {`Access to Emergency Service (after hours)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_24' name='cbCompleteIntakeAssessment_24' className='add-only' value='OfficeLocationAndContactInformation' /> {`Office Location and Contact Information`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCompleteIntakeAssessment_25' name='cbCompleteIntakeAssessment_25' className='add-only' value='VerifiedDiagnosisWithinDays' /> {`Verified diagnosis within 30 days`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Appt Date for Psychiatrist`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='date' id='txtDateForPsychiatrist_1' name='txtDateForPsychiatrist_1' className='add-only' />
                        </td>
                    </tr>                   
                </table>
                <p className='w-750'>
                    My Signature below indicates that all of the above information has been fully explained and is understood by the consumer and family. A written copy of the information has been provided to the consumer and family
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Signature`} </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Statement of Guardianship</h3>
                </p>
                <p className='w-750'>
                    {`I,`}&nbsp;<input type='text' id='txtStatementGuardianship' name='txtStatementGuardianship' className='add-only w-210 custom-add-only' />&nbsp;{`d.o attest that I am the legal guardian of`}&nbsp;<input type='text' id='txtStatementGuardianshipGuardian' name='txtStatementGuardianshipGuardian' className='add-only w-250 custom-add-only' />
                </p>
                <p className='w-750'>
                    {`and have legal authority as recognized by a court of law to request Behavioral Health Services on behalf of the above listed consumer from Cruse Medical Care`}
                </p>
                <p className='w-750'>
                    {`I further agree to provide Cruse Medical Care with all supporting court documentation of above claim given to me by any child protective service or placement agency as provided`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Parent Printed Name </td>
                        <td className='small w-375'> Parent Signature</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Guardian Printed Name</td>
                        <td className='small w-375'>Guardian Signature</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Acknowledgement of Freedom of Choice</h3>
                </p>
                <p className='w-750'>
                    I&nbsp;<input type='text' id='txtParentGuardianship' name='txtParentGuardianship' className='add-only w-210 custom-add-only' />&nbsp;{`Parent/guardian of`}&nbsp;<input type='text' id='txtAcknowledgementFreedomOfChoice' name='txtAcknowledgementFreedomOfChoice' className='add-only w-250 custom-add-only' />&nbsp;{`have voluntarily`}
                </p>
                <p className='w-750'>
                    {`enrolled my child in Non-Intensive/ IFI Mental Health Services. I understand that as the parent/guardian, I have the right to select the provider of my choice. I have, ofmy own free will selected Cruse Medical Care as myNon-Intensive/ IFI Mental Health Services provider`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Individual Printed Name </td>
                        <td className='small w-375'> Individual's Signature </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`CMC Assessor/Wimess Printed Name`} </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`CMC Assessor/Wi1ness Signature`} </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Rights as a Individual</h3>
                </p>
                <p className='w-750'>
                    State and Federal laws protect your rights as a consumer of Cruse Medical Care treatment programs. Below is a simplified outline of those rights: <br />
                    Your Rights Include:
                </p>
                <p className='w-750'>
                    <ul>
                        <li>The right to receive care suited to your needs.</li>
                        <li>The right to receive services that respect your diguity and protect your health</li>
                        <li>The right to pertinent information, including the benefits and risks of your treatment, in sufficient time to make informed decisions</li>
                        <li>The right to participate in planning your own treatment, and the right to request choice over the composition of the service delivery team</li>
                        <li>The right to refuse service, unless a physician or licensed psychologist feels that refusal would be unsafe for you and others</li>
                        <li>The right to prompt and confidential services even if you are unable to pay</li>
                        <li>The right to request an opportunity to'inspect, copy, and correct your records.</li>
                        <li>The right to exercise all civil, political, personal, privacy and property rights to which you are entitled to as a citizen.</li>
                        <li>The right to remain free of physical restraints or time-out procedures unless such measures are required for providing effective treatment or for protecting your safety or the safety of others.</li>
                        <li>The right to be free of physical abuse, including sexual abuse, and physical punishment</li>
                        <li>The right to remain free of psychological abuse, including humiliating, threatening, and exploiting actions.</li>
                        <li>To the extent possible with program guidelines, the right, if you are a residential consumer, to converse privately, to have a reasonable access to a telephone, to receive and send mail, to have visitors, and to retain your personal effects and money</li>
                        <li>The right to file a complaint if you think any of these rights have been restricted or denied. Information on how to file a complaint or contact your Individual's Rights Representative is presented below; you may call or send in a complaint</li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Parent/Guardian Printed Name </td>
                        <td className='small w-375'> Parent/Guardian Signature
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span> </td>
                    </tr>
                </table>
                <p className='W-750'>
                    <h3>Consent to Treatment</h3>
                </p>
                <p className='W-750'>
                    {`This form identifies that I,`}&nbsp;<input type='text' id='txtThisFormIdentifiesThat' name='txtThisFormIdentifiesThat' className='add-only w-210 custom-add-only' />&nbsp;voluntarily give my permission and Consent to
                </p>
                <p className='w-750'>
                    Treatment for&nbsp;<input type='text' id='txtTreatmentFor' name='txtTreatmentFor' placeholder='(PRINT. CHILD NAME)' className='add-only w-210 custom-add-only' />&nbsp;{`to receive Non-Intensive/IFI services  from Cruse Medical  Care`}
                </p>
                <p className='w-750'>
                    {` By signing this page:`}
                </p>
                <p className='w-750'>
                    <ul>
                        <li>I understand that because of the counseling and/or therapy I will receive, there may be emotional strains and depleted feelings during treatment. I also understand that I may make life changes that could be distressing</li>
                        <li>I understand that Cruse Medical Care a part of my treatment and recovery and are not identified as an emergency service; furthermore, I have been informed and provided information on how to call 911 in the case of a medical emergency.</li>
                        <li>I understand that my attendance and engagement in my therapeutic sessions and my compliance with treatment will maximize the benefits of my treatment, but I have been made aware that Cruse Medical Care is consumer driven and I can exercise the right to disengage from treatment at any time. IfI decide to disengage from treatment I will notify Cruse Medical Care at least two weeks in advance so that effective planning for continued care can be implemented</li>
                        <li>I understand that, within certain limits, information regarding my treatment is confidential and will be released to other parties only with my written consent. I have been provided with a summary of those limits and provided a copy of a release of information form.</li>
                        <li>I understand that conversations with the therapist will ahnost always be confidential. I also understand that therapist, by law, must report actual or suspected child or eider abuse to the appropriate authorities. In addition, the therapist has a legal responsibility to protect anyone that may be threatened with violence, harmful or dangerous actions (including those to myself) and may break confidentiality of communication if such a situation arises. I understand that the therapist will make reasonable efforts to resolve these situations before breaking confidentiality.</li>
                        <ul>
                            <li>I know of no reason that I will not be able to undertake in this therapy and I agree to participate fully and voluntarily.</li>
                            <li>I also confirm that I have received a "Welcome Packet" and a copy of "Company Introduction and Services" that identifies Cruse Medical Care and my rights as a consumer</li>
                            <li>I understand that while I am receiving services, periodic surveys may be conducted confidentially by mail and/or by phone, inquiring as to my satisfaction with services being provided. Also, I understand that after completing services, confidential follow-up will be conducted in the same marmer. I understand that my records may be reviewed by a representative from licensing and accreditation agencies and organizations</li>
                        </ul>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>{`Limits of Confidentiality`}</h3>
                </p>
                <p className='w-750'>
                    {`The content of a counseling, intake, or assessment session are considered to be confidential. Both verbal information and written records about a Individual cannot be shared with another party without the written consent of the Individual or the Individual's legal guardian. It is the policy of this organization not to release any information about a Individual without a signed release of information. Noted below are exceptions. Also referred to as Limits of Confidentiality`}
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Duty to Warn and Protect</li>
                        <ul>
                            <li>When a consumer discloses intentions or a plan to harm another person, the health care professional is required to warn the intended victim and report this information to legal authorities. In cases in which the Individual discloses or implies a plan for suicide, the health care professional is required to notify legal authorities and make reasonable attempts to notify the family of the Individual.</li>
                        </ul>
                    </ul>
                    <ul>
                        <li>Abuse of Children and Vulnerable Adults</li>
                        <ul>
                            <li>If a consumer states or suggests that he/she is abusing a child (or vulnerable adult) or has recently abused a child (or vulnerable adult), or a child (vulnerable adult) is suspected to be in danger of abuse, the health care professional is required to report this inforniation to the appropriate social service and/or legal authorities</li>
                        </ul>
                    </ul>
                    <ul>
                        <li>Prenatal Exposure to Controlled Substances</li>
                        <ul>
                            <li>Health care professionals are required to report admitted prenatal exposure to controlled substances that are potentially harmful.</li>
                        </ul>
                    </ul>
                    <ul>
                        <li>In the Event of Death</li>
                        <ul>
                            <li>In the event of a consumer's death, the spouse or parents of a deceased individual have a right to access their child's or spouse's records.</li>
                        </ul>
                    </ul>
                    <ul>
                        <li>Professional Misconduct</li>
                        <ul>
                            <li>Other health care professionals must report professional misconduct by a health care professional.In cases in which a professional or legal disciplinary meeting is being held regarding the heath care professional's actions; related·records may be released in order to substantiate disciplinary concerns.</li>
                        </ul>
                    </ul>
                    <ul>
                        <li>Court Orders</li>
                        <ul>
                            <li>Health care professionals are required to release records of Individual's when a court order has been placed. Individuals who are on probation, court ordered to treatroent or referred by The Departroent of Justice, Departroent of Human Resources, or Mental Health Court may have waived certain rights to confidentiality when entering Intervention programs</li>
                        </ul>
                    </ul>
                </p>
                <p className='w-750'>
                    By signing below I acknowledge that I have been provided a copy of these listed Limits of Confidentiality and understand how they pertain to my treatroent and confidentiality.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Contact Specifications</h3>
                </p>
                <p className='w-750'>
                    {`In the event in which the agency or mental health professional must telephone the Individual for purposes such as appointment cancellations or reminders, or to give/receive other information, efforts are made to preserve confidentiality. Please list where we may reach you by phone and how you would like us to identify ourselves. (You may request to be contacted at home or at work, we do not say the name of the clinic or nature of the call, but rather the mental health professional 's first name only).`}
                </p>
                <p className='w-750'>
                    Please check where you may be reached by phone. Include the telephone number and how you would like us to identify ourselves
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTelePhoneNumberIdentify' name='cbTelePhoneNumberIdentify' className='add-only' value='Home' /> HOME
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>{`Phone number:`}</span></td>
                        <td className='w-375'><span className='eleHeader'>{`How should we identify ourselves:`}</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHowShouldWeIdentifyOurselves' name='txtHowShouldWeIdentifyOurselves' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>{`May we say the clinic name?`}</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbHomeClinic_Yes' name='rbHomeClinic' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHomeClinic_No' name='rbHomeClinic' className='add-only' value='No' /> No
                        </td>
                    </tr> <hr />
                </table><br />
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTelePhoneNumberIdentifyWork' name='cbTelePhoneNumberIdentifyWork' className='add-only' value='Work' /> WORK
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>{`Phone number:`}</span></td>
                        <td className='w-375'><span className='eleHeader'>{`How should we identify ourselves:`}</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhoneNumber_2' name='txtPhoneNumber_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHowShouldWeIdentifyOurselves_2' name='txtHowShouldWeIdentifyOurselves_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>{`May we say the clinic name?`}</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbWorkClinic_Yes' name='rbWorkClinic' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbWorkClinic_No' name='rbWorkClinic' className='add-only' value='No' /> No
                        </td>
                    </tr> <hr />
                </table> <br />
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTelePhoneNumberIdentifyEmergency' name='cbTelePhoneNumberIdentifyEmergency' className='add-only' value='Emergency' /> EMERGENCY
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>{`Name:`}</span></td>
                        <td className='w-375'><span className='eleHeader'>{`Phone number:`}</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_1' name='txtName_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPhoneNumber_3' name='txtPhoneNumber_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>{`How should we identify ourselves:`}</span></td>
                        <td className='w-375'><span className='eleHeader'>{`May we say the clinic name?`}</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHowShouldWeIdentifyOurselves_3' name='txtHowShouldWeIdentifyOurselves_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbEmergencyClinic_Yes' name='rbEmergencyClinic' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbEmergencyClinic_No' name='rbEmergencyClinic' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>{`Acknowledgement of Limits of Confidentiality and Other Provisions`}</u></h3>
                </p>
                <p className='w-750'>
                    <h3>Cruse Medical Care</h3>
                </p>
                <p className='w-750'><h3>HIPPA NOTIFICATION OF CONFIDENTIALITY/PRIVACY REQUIREMENTS</h3> </p>
                <p className='w-750'>
                    <span className='small'>{`This notice describes how medical and drug and alcohol related information about you may be used and disclosed and how you can get access to this information. Please review it carefully`} </span>
                </p>
                <p className='w-750'>
                    <h3><u>General Information</u></h3>
                </p>
                <p className='w-750'>
                    {`Information regarding your health care, including payment for health care is protected by two federal laws: the Health Insurance Portability and Accountability Act of 1996 (HIPAA), 42 USC § 1320d et.seq, 42 CFR Parts 160 and 164, and the Confidentiality Law, 42 USC § 290dd-2, 42 CFR Part 2. Under these laws Hope Rising Corporation ("the Agency") may not say to a person outside the Agency that you attend the program, nor may we disclose any information identifying you as an alcohol or drug abuser, or disclose any other information except as permitted by federal law`}
                </p>
                <p className='w-750'>
                    {`The Agency must obtain your written consent before it can disclose information about you for payment purposes. For example, we must obtain your written consent before we can contact your health insurer in order to be paid for services. Generally, you must also sign a written consent before the Agency can share information for treatment purposes or for health care operations. However, federal law permits us to disclose information without your written permission if the disclosure:`}
                </p>
                <p className='w-750'>
                    <ol>
                        <li>Is allowed by court order</li>
                        <li>Is made to medical personnel in a medical emergency</li>
                        <li>Is made to qualified personnel for research, audit, or program evaluation</li>
                        <li>Is to report a crime or threat to commit a crime either at the Agency or against any person, who works for the Agency</li>
                        <li>Is to appropriate authorities to report suspected child abuse or neglect</li>
                        <li>Is	pursuant	to	a	HIPAA	compliant	agreement	with	a	qualified	service organization/business associate</li>
                    </ol>
                </p>
                <p className='w-750'>
                    {`Before the Agency can use or disclose any information about your health in a manner which is not described above, it must first obtain your specific written consent. Any such written consent may be revoked by you in writing.`}
                </p>
                <p className='w-750'>
                    <h3><u>{`Confidentiality of HIV-Related Information/Reporting Requirements`}</u></h3>
                </p>
                <p className='w-750'>
                    {`Confidential HIV-related information is any information indicating that a patient had an HIV-related test, has an HIV-related illness or AIDS, has an HIV-related infection, or any information which could i,dentify the patient as a person who has had, or currently has HIV infection`}
                </p>
                <p className='w-750'>
                    {`Under Georgia State law, HIV-related information may only be given to persons allowed to have it by release signed by the patient, or to people who need to know the information in order to provide medical care and services, including: medical care providers; persons involved with foster care or adoption; parents and guardians who consent to care of minors; jail, prison, probation and parole employees; emergency response workers and other workers in hospitals; other regulated settings or medical offices whose workers are exposed to blood/body fluids in the course of thefr employment; organizations that review the services patient receive; and under limited circumstances to insurers as necessary to pay for care and treatment`}
                </p>
                <p className='w-750'>
                    {`The law also mandates that names be reported to the State of Georgia Department of Community Health/AIDS Surveillance Unit, of persons with a confirmed positive HIV antibody test result received through a confidential test, other HIV-test results, a diagnosis of AIDS, or if the person tested chose to attach his/her name to a positive test result at an anonymous testing site. Within the Agency, HIV status and related information may be given to administrative staff, treatment staff and support personnel who reasonably need to know patient HIV status in performing their job, in order to provide medical care and treatment services to patients, or to assure the appropriate operations of the program required to maintain Individual services`}
                </p>
                <p className='w-750'>
                    <h3><u>Your Rights</u></h3>
                </p>
                <p className='w-750'>
                    {`Under HIPAA, you·have the right to request restrictions on certain uses and disclosures of your health information. The Agency is not required to agree to any restrictions you request, but if it does agree, then it is bound by that agreement and may not use or disclose any information which you have restricted, except as necessary in a medical emergency. Under HIPAA:`}
                </p>
                <p className='w-750'>
                    <ul>
                        <li>You have the right to request that we communicate with you by alternative means or at an alternative location. The Agency will accommodate such requests that are reasonable and will not request an explanation from you.</li>
                        <li>You also have the right to inspect and copy your own health information that we maintain, except to the extent that the information contains psychotherapy notes or information compiled for use in a civil, criminal or administrative proceeding or in other limited circumstances. Your request must be made in writing, stating the information you wish to review and the reasons for making the request</li>
                        <li>You also have the right, with some exceptions, to amend health care information maintained in the Agency's records, and to request and receive an accounting of disclosures of your health-related information made by the Agency during the six (6) years prior to your request</li>
                        <li>You also have the right to receive a paper copy of this notice</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <h3><u>Our Duties</u></h3>
                </p>
                <p className='w-750'>
                    {`Our Agency is required by law to maintain the privacy of your health information and to provide you with notice of its legal duties and privacy practices with respect to your health information. We are required by law to abide by the terms of this notice. The Agency reserves the right to change the terms of this notice and to make new notice provisions effective for all protected health information it maintains. If any regulations or Agency in practices with respect to confidentiality of records and privacy of patient health information changes, you will be notified by communication in writing to all patients and by clinic posting`}
                </p>
                <p className='w-750'>
                    <h3><u>Complaints and Reporting Violations</u></h3>
                </p>
                <p className='w-750'>
                    {`If you believe that your privacy rights have been violated under HIPAA, you may register a complaint. To register such a complaint, Individuals may speak to their Team Leader, a Program Manager, or the Individual Services Coordinator ("individual Advocate"). You will not be retaliated against for filing such a complaint. All complaints will be fully investigated by the Agency Privacy Officer and Senior Administration and you will be notified of findings`}
                </p>
                <p className='w-750'>
                    {`You also have the right to register a complaint of HIPAA violation to the Secretary of the U.S. Department of Health and Human Services (DHHS). This complaint should be in writing and may be directed to the DHR, Division of MH/DDAD, Personal Advocacy Unit, 2 Peachtree Street NW, Atlanta, Georgia 30303, (404) 657-2258`}
                </p>
                <p className='w-750'>
                    {`Violation of the drug and alcohol patient Confidentiality Law by the Agency is a crime. Suspected violations of the Confidentiality Law may be reported to the U.S. Attorney in the Georgia District.`}
                </p>
                <p className='w-750'>
                    {`Any patient who feels that his/her confidentiality regarding HIV-related information has been broken, may report this to the State of Georgia Department of Community Health. If discrimination occurs as a result of a release of HIV-related information, the Individual may report this to the State of Georgia, Office of Civil Rights at (404)562-7886.`}
                </p>
                <p className='w-750'>
                    <h3><u>Contact</u></h3>
                </p>
                <p className='w-750'>
                    {`For further information, speak to your Team Leader, or contact a Program Manager or the Individual Advocate at (678) 866-1250`}
                </p>
                <p className='w-750'>
                    <h3><u>VERIFICATION:</u></h3> {`I verify that I have read both pages of this notice, discussed the Agency's policies concerning confidentiality and privacy of Individual health information, and that I have received a copy of this.notice`}
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Name: Parent or Guardian</span>
                    <input type='text' id='txtParentGuardianName_1' name='txtParentGuardianName_1' className='add-only' />
                </p>
                <p className='w-750'>
                    <b>Signature:</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Parent/Guardian</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Name: Witness</span>
                    <input type='text' id='txtWitness_1' name='txtWitness_1' className='add-only' />
                </p>
                <p className='w-750'>
                    <b>Signature:</b>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Witness</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>ADVANCE DIRECTIVES INFORMATION</u></h3>
                </p>
                <p className='w-750'>
                    <h3>
                        The Patient Self-Determination Act
                    </h3>
                </p>
                <p className='w-750'>
                    {`As of December 1, 1991 the provisions of the Patient Self-Determination Act became effective. This act requires that certain health care facilities participating in the Medicare or Medicaid programs provide Individuals with information regarding their rights under state law to make decisions regarding medical care. This includes the right to refuse treatment and io execute living wills, powers of attorney, and other advance directives addressing the provision of medical care and psychiatric care. Care will not be denied because an individual does not have an advance directive.`}
                </p>
                <p className='w-750'>
                    <h3>Psychiatric Advanced Directive</h3>
                </p>
                <p className='w-750'>
                    {`Psychiatric Advance Directives is a document that outlines the psychiatric care you would like to receive in the event you become unable to make the decision for yourself. Anyone with a severe and persistent mental illness should consider obtaining one. However, at the present time a psychiatric advance directive is not a legal document in the State of Georgia. There is a bill before the State legislature to make them a legal document`}
                </p>
                <p className='w-750'>
                    <h3>Advance Directive</h3>
                </p>
                <p className='w-750'>
                    {`An advance directive is a written document, such as a living will or durable power of attorney for health care, that makes your wishes clear regarding your medical and psychiatric care if you become unable to communicate your decisions to your care provider`}
                </p>
                <p className='w-750'>
                    <h3>Living Will</h3>
                </p>
                <p className='w-750'>
                    {`A living will is a written directive that lets you state what type of medical treatment you do or do not wish to receive if you are too ill or injured to direct your own care, up to and including withholding or withdrawing life saving and/or sustaining procedures. State law describes a specific kind of form that must be used in order for a living will to be valid.This form must be signed, dated, and witnessed.`}
                </p>
                <p className='w-750'>
                    <h3>Durable Power of Attorney for Health Care</h3>
                </p>
                <p className='w-750'>
                    {`A durable power of attorney, also known as a _medical power of attorney, is a signed, dated, and witnessed legal document in which you designate a trusted person (an agent or attorney-in fact) to make medical decisions for you if you become unable to make the decisions yourself. You can give your agent the authority to oversee the wishes you1ve set out in your health care declaration, as well as the power to make other necessary decisions about health care matters`}
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProviding_1' name='cbProviding_1' className='add-only' value='ICurrentlyHaveFollowingProviding' /> I currently have the following, and am providing CMC staff with a copy:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>&nbsp;</td>
                        <td className='w-710'>
                            <input type='checkbox' id='cbProviding_2' name='cbProviding_2' className='add-only' value='AdvancedDirectivesForMedicalCrisis' /> Advanced Directives for Medical Crisis
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>&nbsp;</td>
                        <td className='w-710'>
                            <input type='checkbox' id='cbProviding_3' name='cbProviding_3' className='add-only' value='AdvancedDirectivesForPsychiatricCrisis' /> Advanced Directives for Psychiatric Crisis
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProviding_4' name='cbProviding_4' className='add-only' value='IdoNotHaveAnyAdvancedDirectives' /> I do not have any Advanced Directives
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>If you are interested in obtaining an Advanced Directive you may contact:</b>
                </p>
                <p className='w-750'>
                    {`The Georgia Mental Health Individual Network `} <br />
                    {`1-800-297-6146`}
                </p>
                <p className='w-750'><a href='www.gmhcn.org' > www.gmhcn.org</a></p>
                <p className='w-750'>
                    {`National Mental Health Association (NAMI) `} <br />
                    {`1-800-969-6642`}
                </p>
                <p className='w-750'><a href='www.nmha.org/position/advanceddirectives.cfin' > www.nmha.org/position/advanceddirectives.cfin</a></p>
                <p className='w-750'>
                    <b>{`CMC staff may not assist in the writing or witnessing of a Psychiatric Advance Directive`}</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Individual</span> </td>
                        <td className='w-375'> <span className='eleHeader'>{`Witness ( Parent )`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtIndividual' name='txtIndividual' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtWitnessParent' name='txtWitnessParent' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>SCHOOL INVOLVEMENT CONSENT FORM</u></h3>
                </p>
                <p className='w-750'>
                    {`As the Parent/Guardian(s) of`}&nbsp;<input type='text' id='txtParentGuardianOf' name='txtParentGuardianOf' className='add-only w-200 custom-add-only' /> I here by give CMC permission to provide behavioral
                </p>
                <p className='w-750'>
                    {`assistance regarding my child's academic progress in the classroom, including testing, counseling, consultation,	`}
                </p>
                <p className='w-750'>
                    and	any	other	behavioral	or	academic	support	at&nbsp;<input type='text' id='txtParentGuardianOf_1' name='txtParentGuardianOf_1' placeholder='PRINT CHILD SCHOOL NAME' className='add-only w-400 custom-add-only' />&nbsp;{`as,deemed necessary`}
                </p>
                <p className='w-750'>
                    I understand that I will ALWAYS be given prior notice of such actions
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProvidingConsent_4' name='cbProvidingConsent_4' className='add-only' value='ParentGuardianDeclinedToProvideConsent' /> Parent/Guardian Declined To Provide Consent
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        USE THIS SPACE ONLY IF CLIENT WITHDRAWS CONSENT
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                        <td className='small w-375'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        <u>RELEASE TO PROVIDE TRANSPORTATION CONSENT FORM</u>
                    </h3>
                </p>
                <p className='w-750'>
                    {`As the Parent/Guardian(s) of`}&nbsp;<input type='text' id='txtParentGuardianOfOne' name='txtParentGuardianOfOne' className='add-only w-200 custom-add-only' /> I here by give CMC Staff members permission to use
                </p>
                <p className='w-750'>
                    their Personal vehicle to transport&nbsp;<input type='text' id='txtParentGuardianOf_2' name='txtParentGuardianOf_2' placeholder='PRINT CHILD NAME' className='add-only w-400 custom-add-only' />
                </p>
                <p className='w-750'>
                    {`For the following reason(s )Medical, educational, and other treatment related activities, during the specified course of treatment`}
                </p>
                <p className='w-750'>
                    {`I understand that transportation is voluntary. Furthermore, during transportation the treatment team member will not knowingly or intentionally place my minor child or myself in danger and will immediately notify or seek guidance`}
                </p>
                <p className='w-750'>
                    {`from the Clinical Director and/or emergency assistance if unforeseen circumstances occur that require any such public emergency official services`}
                </p>
                <p className='w-750'>
                    {`I understand that I will ALWAYS be given prior notice of such actions`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProvidingConsent_1' name='cbProvidingConsent_1' className='add-only' value='ParentGuardianDeclinedToProvideConsent' /> Parent/Guardian Declined To Provide Consent
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        USE THIS SPACE ONLY IF CLIENT WITHDRAWS CONSENT
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                        <td className='small w-375'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        <u>{`Audio/Video Consent Form`}</u>
                    </h3>
                </p>
                <p className='w-750'>
                    {`On certain occasions interviews and treatment sessions and outings associated with Cruse Medical Care may be audio/video taped, aud/or observed, The purpose of these procedures is to provide for high quality innovative professional services and for use in internal training within Cruse Medical Care`}
                </p>
                <p className='w-750'>
                    {`I,`}&nbsp;<input type='text' id='txtAuthorizeTheProduction' name='txtAuthorizeTheProduction' className='add-only w-250 custom-add-only' />&nbsp;{`consent to and authorize the production of audio/video tape recordings, and photography, within the confinement of my treatment with Cruse Medical Care`}
                </p>
                <p className='w-750'>
                    {`I understand that all information so obtained will be handled in complete confidence to the extent allowed by law. I understand that I may revoke this consent at any time, I further understand that information will not be released to unauthorized agencies or individuals without my expressed, written consent.`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProvidingConsent_2' name='cbProvidingConsent_2' className='add-only' value='ParentGuardianDeclinedToProvideConsent' /> Parent/Guardian Declined To Provide Consent
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        <u>Consent to Publication of Photographs and Film</u>
                    </h3></p>
                <p className='w-750'>
                    {`I,`}&nbsp;<input type='text' id='txtConsentPhotographed' name='txtConsentPhotographed' className='add-only w-250 custom-add-only' />&nbsp;{`consent to being photographed and filmed while attending programs at`}
                </p>
                <p className='w-750'>
                    <b>Cruse Medical Care</b> {`.I further consent to the publication and/or public display of these photographs or film for the purposes of celebrating consumer achievement, consumer advocacy and/or raising awareness of the services provided by `} <b>Cruse Medical Care</b>
                </p>
                <p className='w-750'>
                    {`*I also consent to the publication ofmy child's name along with the image.* `}
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbInitialIfApplicable' name='cbInitialIfApplicable' className='add-only' value='InitialIfApplicable' /> Initial if applicable
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    {`This consent is valid for a period of (1) one year from the date of signing. I have the right to withdraw this consent at any time. Withdrawal of consent will only pertain to those images captured after notification of withdrawn consent. Those images already published during the period of consent cannot be reasonably withdrawn`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProvidingConsent_3' name='cbProvidingConsent_3' className='add-only' value='ParentGuardianDeclinedToProvideConsent' /> Parent/Guardian Declined To Provide Consent
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        USE THIS SPACE ONLY IF CLIENT WITHDRAWS CONSENT
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                        <td className='small w-375'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        <u>Acknowledgement of Group</u>
                    </h3>
                </p>
                <p className='w-750'>
                    {`There presents 1he opportunity, in certain circumstances, for an individual's treatment to be implemented in a group session. Group is defined as a joint therapeutic session held between two peers and one counselor. The two participants are required to have similar goals in their treatment and require the same intervention. These sessions, like all sessions in therapy, present the opportunity for increased anxiety, as made aware in the Consent to Treatment. Cruse Medical Care staff will conduct confidentiality to its fullest standing, yet in a group session both peers involved are advised to exercise strict confidentiality; Cruse Medical Care does not assume responsibility for the individual's actions. Each individual involved has the choice of providing an alias name lo protect their identity. Cruse Medical Care will conduct confidentiality to the fullest and provide individual documentation related to the group session. All individuals will have a session by session choice of what group they will like to participate in. Individuals involved in group therapy will be prov;ded a Release of Information form on each occasion to consent to group session. Consent can be voided at any time before and during the session.`}
                </p>
                <p className='w-750'>
                    By signing below,
                </p>
                <p className='w-750'>
                    {`I`}&nbsp;<input type='text' id='txtAwareOpportunity' name='txtAwareOpportunity' className='add-only w-300 custom-add-only' />&nbsp;{`am aware of1he opportunity to conduct therapeutic sessions `}
                </p>
                <p className='w-750'>
                    with peer interaction as indicated by <b>Cruse Medical Care</b> I also aclmowledge that I have been made aware ofmy right to decline such sessions and the implications involved with accepting.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Cruse Medical</h3>
                </p>
                <p className='w-750'><h3>GRIEVANCE AND COMPLAINT PROCEDURE</h3> </p>
                <p className='w-750'>
                    <span className='small'>{`It is the policy of Cruse Medical to provide an immediate and fair method of resolving consumer grievances/complaints`} </span>
                </p>
                <table>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'>Individual Name:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtIndividualName_1' name='txtIndividualName_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfBirth_1' name='txtDateOfBirth_1' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Phase 1:</b> {`If a grievance is filed the following steps must be taken by the consumer/family:`}
                </p>
                <p className='w-750'>
                    <ul>
                        <li>
                            Report the grievance at the program level to the Administrative Manager, This can be reported verbally or written. Staff can file on behalf of consumer.
                        </li>
                        <li>The Administrative Manager wlll investigate and evaluate the grievance to determine when the Investigation should take place at the center level.
                        </li>
                        <li>At the center leve!i the Clinical director will:</li>
                        <ol type='a'>
                            <li>Interview individual who filed the grievance and obtain information regardlng the</li>
                            <li>compliant</li>
                            <li>Notify the staff member to whom the grievance Is filed against.</li>
                            <li>Work with the staff and lndlvidua! to come up with, and take action on, a solution.</li>
                        </ol>
                    </ul>
                </p>
                <p className='w-750'>
                    <b>Phase 2:</b> {`If solution ls not obtained the grievance will be filed with the Clinical Dlrector and within 7 working days, the Clinical Director will complete all steps In Phase 1. Resolution should take place through mediation and reconclllation, facilitated by the Clinical Director. The Clinical Director may reject the grievance if no solution Is achieved, The Cllnlcal Director files report to the Program Director whom w!ll provide copies of the grievance to the consumer and staff involved`}
                </p>
                <p className='w-750'>
                    <b>Phase 3:</b> {`If the consumer or legal guardian appeals the solution, he may submit a written rejection letter within 7 days and file an appeal. The Program Director and Clfnlcal Director will met with consumer to discuss the grievance`}
                </p>
                <p className='w-750'>
                    <b>Phase 4:</b> {`If the consumer Is dissatisfied with the decision by the Center Director (s), the grievance ls then filed with the appropriate OHR official within 10 days, The DHR official, within 14 days, will provide a fin ! decision.`}
                </p>
                <p className='w-750'>
                    {`Address for filing compliant to DHR:`} <br />
                    {`DHR, Division of MH/DD/AD, Personal Advocacy Unit 2 Peachtree Street NW`} <br />
                    {`Atlanta, Georgia 30303, 404-657-22S8`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Individual/Legal Guardian Name`} </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-500'> {`Individual/Legal Guardian Signature`} </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Treatment Team`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        <u>Financial Data</u>
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'>{`Parent's/Guardian's Name:`}</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtParentsGuardianNameDone' name='txtParentsGuardianNameDone' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateParents' name='txtDateParents' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>{`Name of Employer`}</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Address of Employer</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameofEmployer' name='txtNameofEmployer' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAddressOfEmployer' name='txtAddressOfEmployer' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>{`Position/Title`}</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Supervisor</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPositionTitle' name='txtPositionTitle' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSupervisor' name='txtSupervisor' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Source of Income</b>
                </p>
                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>TYPE</span> </td>
                        <td className='w-250'> <span className='eleHeader'>AMOUNT</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> Wages </td>
                        <td className='w-250'> <input type='text' id='txtAmount' name='txtAmount' placeholder='$' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> Child Support </td>
                        <td className='w-250'> <input type='text' id='txtAmount_1' name='txtAmount_1' placeholder='$' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> SSI/SSDI </td>
                        <td className='w-250'> <input type='text' id='txtAmount_2' name='txtAmount_2' placeholder='$' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> Food Stamps </td>
                        <td className='w-250'> <input type='text' id='txtAmount_3' name='txtAmount_3' placeholder='$' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> Other </td>
                        <td className='w-250'> <input type='text' id='txtAmount_4' name='txtAmount_4' placeholder='$' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Do you have health insurance coverage?</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Do you intend to use it to pay for services?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbHealthInsuranceCoverage_Yes' name='rbHealthInsuranceCoverage' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHealthInsuranceCoverage_No' name='rbHealthInsuranceCoverage' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbIntendToPayService_Yes' name='rbIntendToPayService' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbIntendToPayService_No' name='rbIntendToPayService' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>If no, how do you intend to pay for services?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtIntentToPayForServiceIfNo' name='txtIntentToPayForServiceIfNo' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>If yes, please complete the following insurance information:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Insurance Company:</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInsuranceCompany_1' name='cbInsuranceCompany_1' className='add-only' value='Bcbs' /> BCBS
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInsuranceCompany_2' name='cbInsuranceCompany_2' className='add-only' value='CHAMPUSTriCare' /> CHAMPUS/Tri Care
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInsuranceCompany_3' name='cbInsuranceCompany_3' className='add-only' value='Medicare' /> Medicare
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInsuranceCompany_4' name='cbInsuranceCompany_4' className='add-only' value='Aetna' /> Aetna
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInsuranceCompany_5' name='cbInsuranceCompany_5' className='add-only' value='Cigna' /> Cigna
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInsuranceCompany_6' name='cbInsuranceCompany_6' className='add-only' value='HealthPartner' /> Health Partners
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbInsuranceCompany_7' name='cbInsuranceCompany_7' className='add-only' value='Other' /> Other
                            <input type='text' id='txtInsuranceCompany' name='txtInsuranceCompany' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>{`Medicaid#`}</span> </td>
                        <td className='w-375'> <span className='eleHeader'>{`Policy#`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedicade_1' name='txtMedicade_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPolicy_1' name='txtPolicy_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>{`Enrollment/plan/group number:`}</span> </td>
                        <td className='w-150'> <span className='eleHeader'>{`Effective date`}</span> </td>
                        <td className='w-300'> <span className='eleHeader'>{`Deductible met for year?`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtEnrollmentPlanGroupNumber' name='txtEnrollmentPlanGroupNumber' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtEffectiveDate' name='txtEffectiveDate' className='add-only' /> </td>
                        <td className='w-300'>
                            <input type='radio' id='rbDeductibleMetforYear_Yes' name='rbDeductibleMetforYear' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDeductibleMetforYear_No' name='rbDeductibleMetforYear' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>{`Relationship to policyholder:`}</span> </td>
                        <td className='w-250'> <span className='eleHeader'>{`Provider's Address:`}</span> </td>
                        <td className='w-250'> <span className='eleHeader'>{`Provider's Phone:`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtRelationshipPolicyHolder' name='txtRelationshipPolicyHolder' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtProviderAddress_1' name='txtProviderAddress_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtProviderPhone' name='txtProviderPhone' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>{`Pre-approval or pre-authorization required?`}</span> </td>
                        <td className='w-375'> <span className='eleHeader'>{`Pre-approval for specific provider?`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbMedicalCondition_Yes' name='rbMedicalCondition' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMedicalCondition_No' name='rbMedicalCondition' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbPreApprovalSpecificProvider_Yes' name='rbPreApprovalSpecificProvider' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPreApprovalSpecificProvider_No' name='rbPreApprovalSpecificProvider' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>{`Pre-approval authorization number:`}</span> </td>
                        <td className='w-375'> <span className='eleHeader'>{`Number/Type sessions pre-approved:`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNoPreApprovalAthorizationNumber' name='txtNoPreApprovalAthorizationNumber' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtNumberTypeSessionsApproved' name='txtNumberTypeSessionsApproved' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I grant this agency permission to release any information obtained during assessments or treatment, which is necessary to support insurance claims for my/our treatment. I understand that I am responsible for all charges, regardless of insurance coverage.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Printed Name`} </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Signature`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        <u>AUTHORIZATION OF TREATMENT PLAN</u>
                    </h3>
                </p>
                <p className='w-750'>
                    {`I understand that a treatment plan with various goals has been developed based upon not only the Strengths, Needs, Abilities, and Preferences (SNAPS) identified during the Biopsychosocial Assessment, but it is also a result of a collaborative effort of one or more of the following: the consumer, the guardian/caregiver, and/or the treatment team.`}
                </p>
                <p className='w-750'>
                    Signing below authorizes the initiation of services.
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Individual Name </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    FOR OFFICE USE ONLY:
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>The reason that a standard acknowledgement (such as the above) of the treatment plan was not obtained:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTreatmentPlanObtained_1' name='cbTreatmentPlanObtained_1' className='add-only' value='IndividualOrCaregiverRefusedToSign' /> Individual or caregiver.refused to sign
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTreatmentPlanObtained_2' name='cbTreatmentPlanObtained_2' className='add-only' value='CommunicationBarriersProhibitedObtainingTheAcknowledgement' /> Communication barriers prohibited obtaining the acknowledgement
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTreatmentPlanObtained_3' name='cbTreatmentPlanObtained_3' className='add-only' value='AnEmergencySituationPreventedThisOfficeFromObtainingIt' /> An emergency situation prevented this office from obtaining it
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTreatmentPlanObtained_4' name='cbTreatmentPlanObtained_4' className='add-only' value='Other' /> Other
                            <input type='text' id='txtTreatmentPlanObtained' name='txtTreatmentPlanObtained' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        <u>AUTHORIZATION FOR RELEASE OF INFORMATION/ MEDICAL RECORDS</u>
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>{`Individual Name:`}</span> </td>
                        <td className='w-150'> <span className='eleHeader'>{`Date of Birth:`}</span> </td>
                        <td className='w-150'> <span className='eleHeader'>{`Date of Treatment:`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtIndividualName_2' name='txtIndividualName_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfBirth_2' name='txtDateOfBirth_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfTreatMent_2' name='txtDateOfTreatMent_2' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>I hereby authorize Cruse Medical Care to RELEASE and/or OBTAIN information TO and/or FROM for the Purpose of</span>
                    <input type='text' id='txtObtainInformationPurposeOF' name='txtObtainInformationPurposeOF' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>{`Name`}</span> </td>
                        <td className='w-250'> <span className='eleHeader'>{`City,State`}</span> </td>
                        <td className='w-250'> <span className='eleHeader'>{`Zip`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtNameOne' name='txtNameOne' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtCityState' name='txtCityState' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>{`Address`}</span> </td>
                        <td className='w-250'> <span className='eleHeader'>{`Phone#Fax#`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' id='txtAddress' name='txtAddress' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPhoneFax' name='txtPhoneFax' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>{`Please release/obtain the following information from my Medical, Education, or Medical Health records: `}</h3>
                    <span className='small'>(NOTE: Specific Information must have a check beside information released,)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>{`RECORDS TO BE RELEASED`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleased_1' name='cbRecordToBeReleased_1' className='add-only' value='TreatmentPlans' /> Treatment Plans
                        </td>
                        <td className='w-225'>
                            <input type='checkbox' id='cbRecordToBeReleased_2' name='cbRecordToBeReleased_2' className='add-only' value='ProgressReports' /> Progress Reports
                        </td>
                        <td className='w-275'>
                            <input type='checkbox' id='cbRecordToBeReleased_3' name='cbRecordToBeReleased_3' className='add-only' value='HealthMedicalRecordsLabEtc' /> Health/Medical Records (Lab, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleased_4' name='cbRecordToBeReleased_4' className='add-only' value='MedicationInformation' /> Medication Information
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleased_5' name='cbRecordToBeReleased_5' className='add-only' value='EducationReports' /> Education Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleased_6' name='cbRecordToBeReleased_6' className='add-only' value='DischargeSummaries' /> Discharge Summaries
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='checkbox' id='cbRecordToBeReleased_7' name='cbRecordToBeReleased_7' className='add-only' value='PsychologicalPsychiatricEvaluation' /> Psychological/Psychiatric Evaluation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleased_8' name='cbRecordToBeReleased_8' className='add-only' value='SocialDevelopmentHistory' /> Social/Development History
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbRecordToBeReleased_9' name='cbRecordToBeReleased_9' className='add-only' value='VerbalCommunication' /> Verbal Communication
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleased_10' name='cbRecordToBeReleased_10' className='add-only' value='BiopyschosocialHistory' /> Biopyschosocial History
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleased_11' name='cbRecordToBeReleased_11' className='add-only' value='HIVRelatedInformation' /> HIV Related Information
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleased_12' name='cbRecordToBeReleased_12' className='add-only' value='AlcoholAndOrDrugInfonnation' /> Alcohol and/or Drug Infonnation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecordToBeReleased_13' name='cbRecordToBeReleased_13' className='add-only' value='Other' /> Other
                            <input type='text' id='txtRecordToBeReleased' name='txtRecordToBeReleased' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>{`RECORDS TO BE REQUESTED`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequested_1' name='cbRecordToBeRequested_1' className='add-only' value='TreatmentPlans' /> Treatment Plans
                        </td>
                        <td className='w-225'>
                            <input type='checkbox' id='cbRecordToBeRequested_2' name='cbRecordToBeRequested_2' className='add-only' value='ProgressReports' /> Progress Reports
                        </td>
                        <td className='w-275'>
                            <input type='checkbox' id='cbRecordToBeRequested_3' name='cbRecordToBeRequested_3' className='add-only' value='HealthMedicalRecordsLabEtc' /> Health/Medical Records (Lab, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequested_4' name='cbRecordToBeRequested_4' className='add-only' value='MedicationInformation' /> Medication Information
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequested_5' name='cbRecordToBeRequested_5' className='add-only' value='EducationReports' /> Education Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequested_6' name='cbRecordToBeRequested_6' className='add-only' value='DischargeSummaries' /> Discharge Summaries
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='checkbox' id='cbRecordToBeRequested_7' name='cbRecordToBeRequested_7' className='add-only' value='PsychologicalPsychiatricEvaluation' /> Psychological/Psychiatric Evaluation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequested_8' name='cbRecordToBeRequested_8' className='add-only' value='SocialDevelopmentHistory' /> Social/Development History
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbRecordToBeRequested_9' name='cbRecordToBeRequested_9' className='add-only' value='VerbalCommunication' /> Verbal Communication
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequested_10' name='cbRecordToBeRequested_10' className='add-only' value='BiopyschosocialHistory' /> Biopyschosocial History
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequested_11' name='cbRecordToBeRequested_11' className='add-only' value='HIVRelatedInformation' /> HIV Related Information
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequested_12' name='cbRecordToBeRequested_12' className='add-only' value='AlcoholAndOrDrugInfonnation' /> Alcohol and/or Drug Infonnation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecordToBeRequested_13' name='cbRecordToBeRequested_13' className='add-only' value='Other' /> Other
                            <input type='text' id='txtRecordToBeRequested' name='txtRecordToBeRequested' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='W-750'>
                    {`I understand that Cruse Medical Care, Inc, are not contingent upon my decision to permit the release of this information and I have consented freely, voluntarily, and without coercion, and that the above information is accurate to the best ofmy knowledge. I understand that I have the right to revoke this authorization at any time to the extent that action has already been taken to comply with it. Information will NOT be disclosed to any other party without written consent of the parent or legal guardian`}
                </p>
                <p className='w-750'>
                    {`This release is protected under state and Federal Confidentiality Regulations (4s, CPR Part 2 and PS 90.503). A copy is valid in lieu of the original. This consent will expire twelve months after the date signed. I understand that this does not affect infonnation released prior to this date. This document can be revoked at any time with the written consent of the consumer and/or guardian`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-500'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Printed Name`} </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Signature`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        <u>AUTHORIZATION FOR RELEASE OF INFORMATION/ MEDICAL RECORDS</u>
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>{`Individual Name:`}</span> </td>
                        <td className='w-150'> <span className='eleHeader'>{`Date of Birth:`}</span> </td>
                        <td className='w-150'> <span className='eleHeader'>{`Date of Treatment:`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtIndividualName_3' name='txtIndividualName_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfBirth_3' name='txtDateOfBirth_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfTreatMent_3' name='txtDateOfTreatMent_3' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>I hereby authorize Cruse Medical Care to RELEASE and/or OBTAIN information TO and/or FROM for the Purpose of</span>
                    <input type='text' id='txtObtainInformationPurposeOF_1' name='txtObtainInformationPurposeOF_1' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>{`Name`}</span> </td>
                        <td className='w-250'> <span className='eleHeader'>{`City,State`}</span> </td>
                        <td className='w-250'> <span className='eleHeader'>{`Zip`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='text' id='txtNameOne_1' name='txtNameOne_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtCityState_1' name='txtCityState_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtZip_1' name='txtZip_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>{`Address`}</span> </td>
                        <td className='w-250'> <span className='eleHeader'>{`Phone#Fax#`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtPhoneFax_1' name='txtPhoneFax_1' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>{`Please release/obtain the following information from my Medical, Education, or Medical Health records: `}</h3>
                    <span className='small'>(NOTE: Specific Information must have a check beside information released,)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>{`RECORDS TO BE RELEASED`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_1' name='cbRecordToBeReleasedOen_1' className='add-only' value='TreatmentPlans' /> Treatment Plans
                        </td>
                        <td className='w-225'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_2' name='cbRecordToBeReleasedOen_2' className='add-only' value='ProgressReports' /> Progress Reports
                        </td>
                        <td className='w-275'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_3' name='cbRecordToBeReleasedOen_3' className='add-only' value='HealthMedicalRecordsLabEtc' /> Health/Medical Records (Lab, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_4' name='cbRecordToBeReleasedOen_4' className='add-only' value='MedicationInformation' /> Medication Information
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_5' name='cbRecordToBeReleasedOen_5' className='add-only' value='EducationReports' /> Education Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_6' name='cbRecordToBeReleasedOen_6' className='add-only' value='DischargeSummaries' /> Discharge Summaries
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_7' name='cbRecordToBeReleasedOen_7' className='add-only' value='PsychologicalPsychiatricEvaluation' /> Psychological/Psychiatric Evaluation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_8' name='cbRecordToBeReleasedOen_8' className='add-only' value='SocialDevelopmentHistory' /> Social/Development History
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_9' name='cbRecordToBeReleasedOen_9' className='add-only' value='VerbalCommunication' /> Verbal Communication
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_10' name='cbRecordToBeReleasedOen_10' className='add-only' value='BiopyschosocialHistory' /> Biopyschosocial History
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_11' name='cbRecordToBeReleasedOen_11' className='add-only' value='HIVRelatedInformation' /> HIV Related Information
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_12' name='cbRecordToBeReleasedOen_12' className='add-only' value='AlcoholAndOrDrugInfonnation' /> Alcohol and/or Drug Infonnation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecordToBeReleasedOen_13' name='cbRecordToBeReleasedOen_13' className='add-only' value='Other' /> Other
                            <input type='text' id='txtRecordToBeReleasedOen' name='txtRecordToBeReleasedOen' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>{`RECORDS TO BE REQUESTED`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_1' name='cbRecordToBeRequestedOne_1' className='add-only' value='TreatmentPlans' /> Treatment Plans
                        </td>
                        <td className='w-225'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_2' name='cbRecordToBeRequestedOne_2' className='add-only' value='ProgressReports' /> Progress Reports
                        </td>
                        <td className='w-275'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_3' name='cbRecordToBeRequestedOne_3' className='add-only' value='HealthMedicalRecordsLabEtc' /> Health/Medical Records (Lab, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_4' name='cbRecordToBeRequestedOne_4' className='add-only' value='MedicationInformation' /> Medication Information
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_5' name='cbRecordToBeRequestedOne_5' className='add-only' value='EducationReports' /> Education Reports
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_6' name='cbRecordToBeRequestedOne_6' className='add-only' value='DischargeSummaries' /> Discharge Summaries
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_7' name='cbRecordToBeRequestedOne_7' className='add-only' value='PsychologicalPsychiatricEvaluation' /> Psychological/Psychiatric Evaluation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_8' name='cbRecordToBeRequestedOne_8' className='add-only' value='SocialDevelopmentHistory' /> Social/Development History
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_9' name='cbRecordToBeRequestedOne_9' className='add-only' value='VerbalCommunication' /> Verbal Communication
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_10' name='cbRecordToBeRequestedOne_10' className='add-only' value='BiopyschosocialHistory' /> Biopyschosocial History
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_11' name='cbRecordToBeRequestedOne_11' className='add-only' value='HIVRelatedInformation' /> HIV Related Information
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_12' name='cbRecordToBeRequestedOne_12' className='add-only' value='AlcoholAndOrDrugInfonnation' /> Alcohol and/or Drug Infonnation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecordToBeRequestedOne_13' name='cbRecordToBeRequestedOne_13' className='add-only' value='Other' /> Other
                            <input type='text' id='txtRecordToBeRequestedOne' name='txtRecordToBeRequestedOne' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='W-750'>
                    {`I understand that Cruse Medical Care, Inc, are not contingent upon my decision to permit the release of this infonnation and I have consented freely, voluntarily, and without coercion, and that the above information is accurate to the best ofmy knowledge. I understand that I have the right to revoke this authorization at any time to the extent that actioll has already been taken to comply with it. Information will NOT be disclosed to any other party without written consent of the parent or legal guardian`}
                </p>
                <p className='w-750'>
                    {`This release is protected under state and Federal Confidentiality Regulations (4s, CPR Part 2 and PS 90.503). A copy is valid in lieu of the original. This consent will expire twelve months after the date signed. I understand that this does not affect infonnation released prior to this date. This document can be revoked at any time with the written consent of the consumer and/or guardian`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>
                <p className='W-750'>
                    <h3>Cruse Medical</h3>
                    <h3>MEDICAL HISTORY FORM</h3>
                    <span className='small'>(Completed by Individual and Parent)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'>{`Individual Name:`}</span> </td>
                        <td className='w-150'> <span className='eleHeader'>{`Date:`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtIndividualName_4' name='txtIndividualName_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate_3' name='txtDate_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>{`Date of Birth:`}</span> </td>
                        <td className='w-150'> <span className='eleHeader'>{`Height:`}</span> </td>
                        <td className='w-150'> <span className='eleHeader'>{`Weight:`}</span> </td>
                        <td className='w-150'> <span className='eleHeader'>{`Age:`}</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateofBirth_3' name='txtDateofBirth_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtHeight' name='txtHeight' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtWeight' name='txtWeight' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtAge' name='txtAge' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'> <span className='eleHeader'>Place a check mark under YES or NO for each medical condition</span> </td>
                        <td className='w-50'><span className='eleHeader'>Yes</span></td>
                        <td className='w-50'><span className='eleHeader'>No</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>If female, are you pregnant?</td>
                        <td className='w-100'>
                            <input type='radio' id='rbFemaleArePregnant_Yes' name='rbFemaleArePregnant' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbFemaleArePregnant_No' name='rbFemaleArePregnant' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>A disorder of the eyes, nose, or throat</td>
                        <td className='w-100'>
                            <input type='radio' id='rbMedicalConditionOne_Yes' name='rbMedicalConditionOne' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMedicalConditionOne_No' name='rbMedicalConditionOne' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Dizziness, fainting, headache, seizure, convulsions, stroke, head trauma (with or without loss of consciousness) or other neurological disease</td>
                        <td className='w-100'>
                            <input type='radio' id='rbMedicalConditionOneO_Yes' name='rbMedicalConditionOneO' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMedicalConditionOneO_No' name='rbMedicalConditionOneO' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Persistent coughing, bronchitis, asthma, emphysema, tuberculosis, or other disorder of the lungs</td>
                        <td className='w-100'>
                            <input type='radio' id='rbMedicalConditionTwo_Yes' name='rbMedicalConditionTwo' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMedicalConditionTwo_No' name='rbMedicalConditionTwo' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Chest pain, igh blood pressure, rheumatic fever, murmur, heart attack, or other disorder of the heart or blood vessels</td>
                        <td className='w-100'>
                            <input type='radio' id='rbMedicalConditionOTu_Yes' name='rbMedicalConditionOTu' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMedicalConditionOTu_No' name='rbMedicalConditionOTu' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Intestinal bleeding, ulcer, hernia, colitis, or other disorder of the stomach, intestines, liver (i.e. hepatitis), or gall bladder</td>
                        <td className='w-100'>
                            <input type='radio' id='rbMedicalConditionOneStomac_Yes' name='rbMedicalConditionOneStomac' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMedicalConditionOneStomac_No' name='rbMedicalConditionOneStomac' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Disorder of kidney, bladder, prostate, or reproductive system including HIV or other sexual transmitted diseases</td>
                        <td className='w-100'>
                            <input type='radio' id='rbMedicalConditionOneHiv_Yes' name='rbMedicalConditionOneHiv' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMedicalConditionOneHiv_No' name='rbMedicalConditionOneHiv' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Diabetes, thyroid, or other endocrine disorders</td>
                        <td className='w-100'>
                            <input type='radio' id='rbMedicalConditionOneDisorder_Yes' name='rbMedicalConditionOneDisorder' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMedicalConditionOneDisorder_No' name='rbMedicalConditionOneDisorder' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Arthritis, or other disorder of the muscles, bones, including spine, back or joints</td>
                        <td className='w-100'>
                            <input type='radio' id='rbMedicalConditionOneBone_Yes' name='rbMedicalConditionOneBone' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMedicalConditionOneBone_No' name='rbMedicalConditionOneBone' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>If sexually active, do you use condoms and/or a means of birth control</td>
                        <td className='w-100'>
                            <input type='radio' id='Birth_Yes' name='Birth' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='Birth_No' name='Birth' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'><b>List all allergies</b></p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Medication</span></td>
                        <td className='w-375'><span className='eleHeader'>Substance</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSubstance_1' name='txtSubstance_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSubstance_2' name='txtSubstance_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Insects</span></td>
                        <td className='w-375'><span className='eleHeader'>Food</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtInsects_1' name='txtInsects_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFood_1' name='txtFood_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtInsects_2' name='txtInsects_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFood_2' name='txtFood_2' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-650'> <span className='eleHeader'>Place a check mark under YES or NO for each symptom that occursfrequently</span> </td>
                        <td className='w-50'><span className='eleHeader'>Yes</span></td>
                        <td className='w-50'><span className='eleHeader'>No</span></td>
                    </tr>
                    <tr>
                        <td className='w-650'>Headaches</td>
                        <td className='w-100'>
                            <input type='radio' id='rbHeadaches_Yes' name='rbHeadaches' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHeadaches_No' name='rbHeadaches' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Hoarse throat</td>
                        <td className='w-100'>
                            <input type='radio' id='rbHoarse throat_Yes' name='rbHoarsethroat' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHoarse throat_No' name='rbHoarsethroat' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Ear infections or pain</td>
                        <td className='w-100'>
                            <input type='radio' id='rbEarInfectionsOrPain_Yes' name='rbEarInfectionsOrPain' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbEarInfectionsOrPain_No' name='rbEarInfectionsOrPain' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Fainting spells</td>
                        <td className='w-100'>
                            <input type='radio' id='rbFaintingSpells_Yes' name='rbFaintingSpells' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbFaintingSpells_No' name='rbFaintingSpells' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Balancing problems</td>
                        <td className='w-100'>
                            <input type='radio' id='rbBalancingProblems_Yes' name='rbBalancingProblems' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbBalancingProblems_No' name='rbBalancingProblems' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Breathing problems/cough</td>
                        <td className='w-100'>
                            <input type='radio' id='rbBreathingProblemsCough_Yes' name='rbBreathingProblemsCough' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbBreathingProblemsCough_No' name='rbBreathingProblemsCough' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Difficult or painful urination</td>
                        <td className='w-100'>
                            <input type='radio' id='rbDifficultorPainfulUrination_Yes' name='rbDifficultorPainfulUrination' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDifficultorPainfulUrination_No' name='rbDifficultorPainfulUrination' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Menstrual pain</td>
                        <td className='w-100'>
                            <input type='radio' id='rbMenstrualPain_Yes' name='rbMenstrualPain' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMenstrualPain_No' name='rbMenstrualPain' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Abdominal pain</td>
                        <td className='w-100'>
                            <input type='radio' id='rbAbdominalPain_Yes' name='rbAbdominalPain' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbAbdominalPain_No' name='rbAbdominalPain' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Nausea/vomiting</td>
                        <td className='w-100'>
                            <input type='radio' id='rbNauseaVomiting_Yes' name='rbNauseaVomiting' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNauseaVomiting_No' name='rbNauseaVomiting' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Chest pain</td>
                        <td className='w-100'>
                            <input type='radio' id='rbChestPain_Yes' name='rbChestPain' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbChestPain_No' name='rbChestPain' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>Fevers</td>
                        <td className='w-100'>
                            <input type='radio' id='rbFevers_Yes' name='rbFevers' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbFevers_No' name='rbFevers' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Explain Any Yes Answer</span>
                    <textarea id='txtExplainAnyYesAnswer' name='txtExplainAnyYesAnswer' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>List current medications</b>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Dosage/Frequency</span></td>
                        <td className='w-250'><span className='eleHeader'>Reason Taken</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtMedicationName_1' name='txtMedicationName_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDosageFrequency_1' name='txtDosageFrequency_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtReasonTaken_1' name='txtReasonTaken_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtMedicationName_2' name='txtMedicationName_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDosageFrequency_2' name='txtDosageFrequency_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtReasonTaken_2' name='txtReasonTaken_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Primary Care Physician Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Telephone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtPrimaryCarePhysicianName_2' name='txtPrimaryCarePhysicianName_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtTelephone_2' name='txtTelephone_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Address:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date of Last Exam</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtAddress_2' name='txtAddress_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateofLastExam_2' name='txtDateofLastExam_2' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Printed Name`} </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Signature`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>EMERGENCY CONTACT INFORMATION</u></h3>
                </p>
                <table>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'>Individual Name:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtIndividualName_6' name='txtIndividualName_6' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfBirth_5' name='txtDateOfBirth_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Medicaid Number (if applicable):</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Social Security #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedicaidNumberApplicable_1' name='txtMedicaidNumberApplicable_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSocialSecurity_1' name='txtSocialSecurity_1' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Please list at least two individuals who can be notified in the event of an emergency if the primary caretaker cannot be reached.</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>RelationShip</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_6' name='txtName_6' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelationShip_1' name='txtRelationShip_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Address:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Contact #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAddress_6' name='txtAddress_6' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtContact_1' name='txtContact_1' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>RelationShip</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_7' name='txtName_7' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelationShip_2' name='txtRelationShip_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Address:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Contact #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAddress_7' name='txtAddress_7' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtContact_2' name='txtContact_2' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Please complete below if you have any of the following:</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Mental HealthProvider Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Fax</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMentalHealthProviderName' name='txtMentalHealthProviderName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFax' name='txtFax' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Address:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Contact #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAddress_8' name='txtAddress_8' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtContact_3' name='txtContact_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Primary CareTaker Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Fax</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPrimaryCareTakerName_6' name='txtPrimaryCareTakerName_6' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFax_1' name='txtFax_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Address:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Contact #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAddress_9' name='txtAddress_9' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtContact_4' name='txtContact_4' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Printed Name`} </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Signature`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>
                <p>
                    <h3>
                        Cruse Medical <br />
                        Treatment Plan <br />
                        Individual/Guardian Participation
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'>Individual Name:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date of Birth:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtIndividualName_7' name='txtIndividualName_7' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfBirth_7' name='txtDateOfBirth_7' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    My signature below attests to the fact I (Individual and or guardian) have been an active participant in the development of the Treatment Plan for the above named Individual. I concur with the recommendations made and the selection of Cruse Medical as the service provider who will provide services outlined in the Treatment Plan
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Parent/Guardian Name`}
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Parent/Guardian Signature`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Individual/Individual Name`}
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Individual/Individual Signature`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`CP Name & Credentials`}
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`CP Name & Credentials Signature`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>Transition/Discharge Plan Signature Plan</u></h3>
                </p>
                <p className='w-750'>MY SIGNATURE BELOW INDICATES I UNDERSTAND ALL OF THE POINTS LISTED IN THE TRANSITION/DISCHARGE PLAN AND HAVE BEEN FURNISHED A COPY OF THE TRANSITION/DISCHARGE PLAN</p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Parent/Guardian Printed Name`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Printed Name`} </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Signature`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3><u>Access to Emergency After Hours Information</u></h3>
                </p>
                <p className='w-750'>
                    Due to the nature of the services being provided, our team of therapists and community support individual are available during days, evenings and weekends. However, in the event of an emergency and you cannot reach your therapist or community support individual, please take the following precautions:
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Call 911</li>
                        <li>Contact the Georgia Crisis Access Line at 1800-715-4225. This source offer 24/7 assistance during non-emergency matters. A licensed mental health professional will assist you</li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Parent/Guardian Printed Name`} </td>
                        <td className='small w-375'> {`Parent/Guardian Signature`}
                            <span className='small'>{`(Of Individual or person authorized to consent for Individual)`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>

                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Printed Name`} </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> {`CMC Assessor/Witness Signature`}
                        </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

            </div>
        </form>

    )
}    